import { render, staticRenderFns } from "./AutomatedTaskList.vue?vue&type=template&id=4edcf3a5"
import script from "./AutomatedTaskList.vue?vue&type=script&lang=js"
export * from "./AutomatedTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports